import React, { useState } from 'react'
import Select from 'react-select'
import { filter } from 'lodash-es'

export const PriceTypeReasonsDropdown = ({
  priceTypeReasons,
  item,
  ticket,
  updateItem
}) => {
  const getTheObj = () => {
    let setPTRId = filter(ticket.priceTypeReasons, {
      id: ticket.priceTypeReasonId
    })
    return setPTRId[0]
  }

  const [priceTypeReasonObj, setPriceTypeReasonObj] = useState(getTheObj())

  const handleChange = priceTypeObj => {
    setPriceTypeReasonObj(priceTypeObj)
    onClickTicketChange(+priceTypeObj.id)
  }

  const updateTickets = (event, ticket) => {
    let newTickets = event.tickets.map(existingTicket => {
      if (existingTicket.priceTypeId === ticket.priceTypeId) {
        return ticket
      }
      return existingTicket
    })
    return newTickets
  }

  const onClickTicketChange = priceTypeReasonId => {
    let newTicket = ticket
    let newItem = item
    newTicket.priceTypeReasonId = priceTypeReasonId

    const newTickets = updateTickets(newItem, newTicket)
    newItem.tickets = newTickets
    updateItem(newItem)
  }

  const customStylesForReactSelect = {
    dropdownIndicator: base => ({
      ...base,
      color: '#000000'
    })
  }

  const getDefaultValue = () => {
    if (priceTypeReasonObj) {
      return priceTypeReasonObj.displayName
        ? { displayName: priceTypeReasonObj.displayName }
        : { name: priceTypeReasonObj.name }
    } else return ''
  }

  // SHEDDWEB-1032: If price type reasons become CMS admin manageable and the displayName editable
  // the the sort will need to be updated to take into account the possibility of displayName
  let sortedPriceTypeReasons = priceTypeReasons.sort((a, b) =>
    a.name > b.name ? 1 : -1
  )

  if (priceTypeReasons.length > 0) {
    return (
      <Select
        className="pt-8"
        options={sortedPriceTypeReasons}
        name="Select one (required)*"
        onChange={handleChange}
        getOptionLabel={option => option.displayName || option.name}
        getOptionValue={option => option.id}
        isSearchable={true}
        setValue={priceTypeReasonObj}
        defaultValue={getDefaultValue()}
        styles={customStylesForReactSelect}
        placeholder={<div className="text-16">Select one (required)</div>}
      />
    )
  } else return <></>
}
